import { TRACKING_DESCRIPTIONS } from '../../components/NewTable/StatusHighlightedDefinitions'

export const NO_INCIDENT_REASON = 'none'

/**
 * Description shown under the shipping status pill. An order at `shipment_with_incident`
 * takes the platform's `incident_reason`; every other status reads the last tracking event.
 * Descriptions outside TRACKING_DESCRIPTIONS are not shown.
 */
export const trackingDescriptionFor = order => {
  if (order.shipping_status === 'shipment_returned') return 'in_return'

  const description = order.shipping_status === 'shipment_with_incident' ? order.incident_reason : order.last_tracking_event?.metadata?.description

  return TRACKING_DESCRIPTIONS.has(description) ? description : null
}

/** The incident comment shown under the status pill: only at `shipment_with_incident`, only when it is a non-blank string. */
export const incidentCommentFor = order => {
  if (order.shipping_status !== 'shipment_with_incident') return null

  return typeof order.incident_comment === 'string' && order.incident_comment.trim() !== '' ? order.incident_comment : null
}

// `in_return` is derived from the shipping status; the platform has no such description to filter on.
export const trackingDescriptionFilterOptions = [
  ...[...TRACKING_DESCRIPTIONS]
    .filter(description => description !== 'in_return')
    .map(description => ({ id: description, label: `statuses.tracking_descriptions.${description}` })),
  { id: NO_INCIDENT_REASON, label: 'orders.filters.tracking_description_none' },
]
